module.exports = __webpack_public_path__ + "fonts/remixicon.7eafaf2d.woff";